export const visit = (vm, at) => {
at({ "es": { "pricingPage": { "detailedTermSelector": { "payMonthly": "Pago mensual", "payAnnually": "Pago anual", "commitMonthly": "Compromiso mensual", "commitAnnually": "Compromiso anual", "bestValue": "Mejor valor" } } } });
};